import { useState } from "react";
import { SectionTitle } from "../../components/SettingsComponents/SectionTitle";
import { Button } from "@etframework/ui.components";
import { useRolePermissions } from "../../data/queries/rolePermissionQueries";
import { PermissionsTable } from "../../components/UserPermissionComponents/PermissionsTable";
import { SettingsAccessTable } from "../../components/UserPermissionComponents/SettingsAccessTable";
import { useUpdateRolePermissions } from "../../data/mutations/rolePermissionsMutations";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

export const Permissions = () => {
  const { t } = useTranslation(["RolePermissions"]);
  const { data } = useRolePermissions();

  var rolePermissionsData = data;

  const { mutate: updateRolePermissions } = useUpdateRolePermissions();
  const [isEditing, setIsEditing] = useState(false);

  const onSetEditing = () => {
    setIsEditing((editing) => !editing);
  };

  const onSaveChanges = () => {
    updateRolePermissions(
      {
        rolePermissions: rolePermissionsData,
      },
      {
        onSuccess: () => {
          toast.success(t("Success"), {
            position: "bottom-left",
          });
          onSetEditing();
        },
        onError: () => {
          toast.error(t("ErrorMsg"), { position: "bottom-left" });
        },
      }
    );
  };

  return (
    <>
      <SectionTitle title={t("Header")} />
      <div className="et-user-permissions module-layout-content h-100 et-board-list-scrollable-container">
        <div className="m-4 permissions-content">
          <div className="d-flex justify-content-between align-items-center m-4">
            <div className="col-3">{t("Title")}</div>
            <div>
              {isEditing ? (
                <div className="d-flex justify-content-end gap-3">
                  <Button
                    id={"dd_settings_role-permissions_cancel-button"}
                    text={t("Cancel")}
                    className="btn-tertiary w-auto"
                    onClick={onSetEditing}
                  />
                  <Button
                    id={"dd_settings_role-permissions_save-button"}
                    text={t("Save")}
                    className="btn btn-primary w-auto"
                    onClick={onSaveChanges}
                  />
                </div>
              ) : (
                <Button
                  text={t("Edit")}
                  id={"dd_settings_role-permissions_edit-button"}
                  className="btn-tertiary w-auto"
                  onClick={onSetEditing}
                  iconCss="fa-regular fa-pencil"
                />
              )}
            </div>
          </div>
          <hr />
          <PermissionsTable
            id={"dd_settings_role-permissions_task-permissions-table"}
            rolePermissionsData={rolePermissionsData}
            isEditing={isEditing}
          />
          <hr />
          <SettingsAccessTable
            id={"dd_settings_role-permissions_access-permissions-table"}
            rolePermissionsData={rolePermissionsData}
            isEditing={isEditing}
          />
        </div>
      </div>
    </>
  );
};
